import { t } from "../../utils/i18n";
export const filtersMapping = {
  get pending() { return t("account.activities.pending"); },
  get completed() { return t("account.activities.completed_status"); },
  get unconfirmed() { return t("account.activities.unconfirmed"); },
  get needs_confirmation() { return t("account.activities.needs_confirmation"); }
};

export const typesMapping = {
  get "sent transfer"() { return t("account.activities.type_sent_transfer"); },
  get "funding deposit"() { return t("account.activities.type_funding_deposit"); },
  get "payout withdrawal"() { return t("account.activities.type_payout_withdrawal"); },
  get "convert deposit"() { return t("account.activities.type_convert_deposit"); },
  get "received transfer"() { return t("account.activities.type_received_transfer"); },
  get "migration transfer"() { return t("account.activities.type_migration_transfer"); },
  get "sent withdrawal"() { return t("account.activities.type_sent_withdrawal"); },
  get transaction() { return t("account.activities.type_store_widget"); }
};
